export const scene1Frames = [
  // 4
  {
    url: 'Scene4',
    position: {
      yaw: 48.65 * Math.PI / 180,
      pitch: -2.9 * Math.PI / 180,
    },
    transformations: {
      perspective: {
        extraTransforms: 'perspective(793px) rotateY(-25deg) rotateX(1deg) skewX(1deg) skewY(-2deg) scale(0.25)'
      }
    },
    style: {
      width: '792px',
      height: '544px',
      backgroundSize: 'contain',
    }
  },
  // 5
  {
    url: 'Scene5',
    position: {
      yaw: 87.55 * Math.PI / 180,
      pitch: -3.6 * Math.PI / 180,
    },
    transformations: {
      perspective: {
        extraTransforms: 'scale(0.4)'
      }
    },
    style: {
      width: '795px',
      height: '445px',
      backgroundSize: 'contain',
    }
  },
  // 6
  {
    url: 'Scene6',
    position: {
      yaw: 137.2 * Math.PI / 180,
      pitch: -2.5 * Math.PI / 180,
    },
    transformations: {
      perspective: {
        extraTransforms: 'perspective(414px) rotateY(23deg) skewX(0deg) skewY(3deg) scale(0.2)'
      }
    },
    style: {
      width: '815px',
      height: '610px',
      backgroundSize: 'contain',
    }
  },
  // 7
  {
    url: 'Scene7',
    position: {
      yaw: -114.8 * Math.PI / 180,
      pitch: -2.95 * Math.PI / 180,
    },
    transformations: {
      perspective: {
        extraTransforms: 'perspective(893px) rotateY(-15deg) skewY(-1deg) scale(0.33333333)'
      }
    },
    style: {
      width: '735px',
      height: '444px',
      backgroundSize: 'contain',
    }
  },
  // 8
  {
    url: 'Scene8',
    position: {
      yaw: -81.2 * Math.PI / 180,
      pitch: -2.65 * Math.PI / 180,
    },
    transformations: {
      perspective: {
        extraTransforms: 'perspective(193px) rotateY(1deg) scale(0.3333333333)'
      }
    },
    style: {
      width: '687px',
      height: '393px',
      backgroundSize: 'contain',
    }
  },
  // 9
  {
    url: 'Scene9',
    position: {
      yaw: -58.4 * Math.PI / 180,
      pitch: -2.3 * Math.PI / 180,
    },
    transformations: {
      perspective: {
        extraTransforms: 'perspective(993px) rotateY(17deg) skewY(1deg) scale(0.25)'
      }
    },
    style: {
      width: '704px',
      height: '448px',
      backgroundSize: 'contain',
    }
  },
  // 10
  {
    url: 'Scene10',
    position: {
      yaw: -23.65 * Math.PI / 180,
      pitch: -1.2 * Math.PI / 180,
    },
    transformations: {
      perspective: {
        extraTransforms: 'perspective(493px) rotateY(41deg) skewY(2deg) scale(0.1)'
      }
    },
    style: {
      width: '590px',
      height: '620px',
      backgroundSize: 'contain',
    }
  },
];
